<script>
export default {
	name: 'MAGMobileCountrySelector',
};
</script>

<script setup>
import OverlayDrawer from '~/components/OverlayDrawer.vue';
import MobileDrawerHeader from '~/components/MAGHeader/MAGMobileDrawerHeader.vue';

const props = defineProps({
	isVisible: { type: Boolean, default: false },
	preferredLanguageLabel: { type: String, default: '' },
	allLanguages: { type: Array, default: () => [] },
});
const emit = defineEmits([
	'update:isVisible',
	'click:header-x',
]);

const siteName = window.siteName;

</script>

<template>
<OverlayDrawer
	:isVisible="props.isVisible"
	class="text-white"
	style="--overlay-container-bg-color: var(--secondary-midnightgreen-extradark);"
	@update:is-visible="$emit('update:isVisible', $event)"
>
	<div class="MobileCountrySelector overflow-y-auto">
		<MobileDrawerHeader
			class="sticky top-0 bg-secondary-midnightgreen-extradark z-10"
			@click:header-x="$emit('click:header-x', false)"
		/>

		<div class="px-6 mt-4">
			<div class="typo-category-title mb-4">{{ props.preferredLanguageLabel }}</div>

			<nav aria-label="Selected Language">
				<div class="flex flex-col gap-4">
					<template
						v-for="(language, languageIndex) in props.allLanguages"
						:key="languageIndex"
					>
						<AppHyperlink
							:href="language.path"
							class="link font-medium"
							:aria-label="`${language.languageTitle}`"
							:forceATag="true"
							:addHtmlExtension="false"
						>
							{{ language.languageTitle }}
						</AppHyperlink>
					</template>
				</div>
			</nav>
		</div>
	</div>
</OverlayDrawer>
</template>


<style scoped lang="scss">
@use 'sass:color';
@use '~/styles/partials/_var.scss';

.MobileCountrySelector {
	max-height: 100vh;
	max-height: 100svh;
}

.separator {
	background-color: #303751;
}
.menu-item {
	border-bottom: 1px solid #303751;
}
.link {
	color: var(--neutral-white-base);
}

</style>
